// @ts-nocheck
/** Allowed country names for call centre create/edit (temporary restriction). */
const ALLOWED_COUNTRY_KEYWORDS = ["india", "australia"];

const INDIA_TZ_KEYWORDS = [
  "india",
  "kolkata",
  "mumbai",
  "chennai",
  "delhi",
  "calcutta",
  "asia/kolkata",
];

const AUSTRALIA_TZ_KEYWORDS = [
  "australia",
  "sydney",
  "melbourne",
  "brisbane",
  "perth",
  "adelaide",
  "darwin",
  "hobart",
  "canberra",
  "australia/",
];

function matchesTimezoneRegion(tzValue, region) {
  const v = String(tzValue || "").toLowerCase();
  const keywords = region === "india" ? INDIA_TZ_KEYWORDS : AUSTRALIA_TZ_KEYWORDS;
  return keywords.some((k) => v.includes(k));
}

export function filterCallCentreCountryCodes(list) {
  return (list || []).filter((country) => {
    const name = String(country?.name || "").toLowerCase();
    return ALLOWED_COUNTRY_KEYWORDS.some((keyword) => name.includes(keyword));
  });
}

/** Restrict timezone list to India / Australia zones only. */
export function filterCallCentreTimezonesList(list) {
  return (list || []).filter(
    (tz) =>
      matchesTimezoneRegion(tz?.value, "india") ||
      matchesTimezoneRegion(tz?.value, "australia")
  );
}

export function filterCallCentreTimezonesForCountry(allTimezones, country) {
  const base = filterCallCentreTimezonesList(allTimezones);
  if (!country) return base;

  const countryName = String(country.name || "").toLowerCase();
  if (countryName.includes("india")) {
    return base.filter((tz) => matchesTimezoneRegion(tz?.value, "india"));
  }
  if (countryName.includes("australia")) {
    return base.filter((tz) => matchesTimezoneRegion(tz?.value, "australia"));
  }
  return base;
}
